<template>
    <div class="contain desFile">
        <div class="header-box">
            销售管理
        </div>
        <div class="box">
            <div class="build-bar">
                <span>项目名称：</span>
                <el-input placeholder="请输入项目名称" v-model="search.name" style="width:12vw;"></el-input>
                <el-button type="primary" class="add-user" @click="doFilter" style="margin-left:1vw;">查询</el-button>
            </div>
            <div class="box-content " style="height: calc( 100% - 100px );">
                <el-table
                    :data="listData"
                    border
                    stripe
                    height="calc( 100% - 50px )"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" width="60">
                        <template slot-scope="scope">
                            <span>{{ scope.row.index }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="项目名称">
                        <template slot-scope="scope">
                            <span>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="位置">
                        <template slot-scope="scope">
                            <span>{{ scope.row.address }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="描述">
                        <template slot-scope="scope">
                            <span>{{ scope.row.note }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="效果图">
                        <template slot-scope="scope">
                            <el-image v-for="item in scope.row.imgList" :key="item" style="width: 50px; height: 50px" :src="item" :preview-src-list="scope.row.imgList"></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建人">
                        <template slot-scope="scope">
                            <span>{{ scope.row.userName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.createDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleEdit(scope.$index, scope.row)" style="padding-left:10px;padding-right:10px;">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 表单列表 -->
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[3, 5, 10, 20]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalItems"
                    style="padding-top:10px;padding-bottom: 10px;background: #fff;"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
// import PDF from 'pdfjs-dist'
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
    data(){
        return{
            // pageTitle:'',
            // labelPosition:'right',
            listData:[],//项目列表
            // listData1:[],//通讯录列表
            groupId:"",
            cuid:'1',
            // curFile:{
            //     type:'',
            //     materiaType:'',
            //     groupId:'',
            //     entProjectId:'',
            //     attachment:'',
            //     attachmentName:'',
            //     attachmentType:'',
            //     userId:'',
            //     userName:'',
            // },
            search:{
                responsiblePerson:'',
                phone:'',
                name:''
            },
            // uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
            // uploadHead:{  //上传接口header
            //     accessToken:this.$store.state.token
            // },
            entProjectId:'',
            // dataList:[],
            // pages: [],
            // pdfDoc: null,
            // addFormVisible:false,
            // addForm:{
            //     id:'',
            //     changeNumber:'',
            //     changeDescribe:'',
            //     changeResults:'',
            //     changeTime:util.myTime.getCurTime()
            // },
            // fileName:'',
            // wordUrl:'',//word文档地址
            // nodeName:[],
            // rules:{
            //     changeNumber: [
            //         { required: true, message: '请输入编号', trigger: 'blur' }
            //     ],
            //     changeDescribe: [
            //         { required: true, message: '请输入简述', trigger: 'blur' }
            //     ],
            //     changeResults: [
            //         { required: true, message: '请输入结果', trigger: 'blur' }
            //     ],
            // },
            dataText:'数据加载中...',
            // dataText1:'数据加载中...',
            // master:{
            //     id:'',
            //     // entProjectId:'',
            //     positions:'',
            //     responsiblePerson:'',
            //     phone:'',
            //     weiXin:'',
            //     email:'',
            //     personId:'',
            //     entProjectName:'',
            // },
            // isAddFlag:false,
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
        }
    },
    mounted() {
        this.groupId = this.$store.state.groupId;
        if(''==this.groupId){
            this.$store.commit('setGroupId');
            this.groupId = this.$store.state.groupId;
        }
        this.entProjectId = this.$route.params.id
        this.getProject()
    },
    methods:{
        doFilter(){
            this.getProject()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentChangePage()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.currentChangePage();
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getProject();
        },
        //通讯录查询
        // doFilterMail(){
        //     this.getMail()
        // },
        //获取数据
        // getData(){
        //     this.getDataByType([])
        //     var that = this
        //     myHttp.getAttachmentType({
        //         type:this.cuid,
        //         groupId:this.groupId,
        //     }).then(function(resp){
        //         if(resp.data.code=='200'){
        //             that.getDataByType(resp.data.data)
        //         }
        //     })
        // },
        //获取项目
        getProject(){
            var that = this
            this.search.groupId = this.groupId
            this.search.pageNum = this.currentPage
            this.search.pageSize = this.pageSize
            myHttp.getEntProjectList(this.search).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.entProject.list;
                    for(var i=0;i<list.length;i++){
                        list[i].index = list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
                        var img = list[i].effectImage&&list[i].effectImage!=''?list[i].effectImage.split(','):[]
                        for(var j=0;j<img.length;j++){
                            img[j] = base.httpCtx+img[j]
                        }
                        list[i].imgList = img
                    }
                    that.listData = list;
                    that.totalItems = resp.data.data.entProject.total
                    if(that.listData.length==0){
                        that.dataText = "暂无数据"
                    }
                }
            })
        },
        //获取通讯录
        // getMail(){
        //     var that = this
        //     this.search.entProjectId = this.entProjectId 
        //     myHttp.selectAddressBookList(this.search).then(function(resp){
        //         if(resp.data.code=='200'){
        //             var list = resp.data.data.addressBook||[];
        //             for(var i=0;i<list.length;i++){
        //                 list[i].index = i+1
        //                 list[i].isSet = false
        //             }
        //             that.listData1 = list;
        //             if(that.listData1.length==0){
        //                 that.dataText1 = "暂无数据"
        //             }
        //         }else{
        //             that.dataText1 = "暂无数据"
        //         }
        //     })
        // },
        //根据type展示数据
        // getDataByType(data){
        //     var dataList = [];
        //         var list = data['list1']||[]
        //         var obj = {}
        //         if(list.length==0){
        //             obj = {
        //                 attachments:[],
        //                 materiaType:'1'
        //             }
        //         }else{
        //             obj = list[0]
        //             var li = obj.attachments||[]
        //             for(var j=0;j<obj.attachments.length;j++){
        //                 obj.attachments[j].fileType = this.getImg(obj.attachments[j].attachment)
        //             }
        //         }
        //         dataList.push(obj)
        //     this.dataList = dataList
        //获取节点名称
        // getNameByType(type){
        //     var result = ''
        //     var list = this.nodeName[parseInt(this.cuid)-1]
        //     for(var i=0;i<list.length;i++){
        //         if(list[i].id==type){
        //             result = list[i].name
        //         }
        //     }
        //     return result
        // },
        //获取图片
        // getImg(url){
        //     // 1:word   2:excel    3:pdf     4:img   5:undefined
        //     var result = '';
        //     var list = url.split('.')
        //     var str = list[list.length-1]
        //     if(base.docType.indexOf(str)>=0){
        //         result = '1'
        //     }else if(base.imgType.indexOf(str)>=0){
        //         result = '4'
        //     }else if(base.excelType.indexOf(str)>=0){
        //         result = '2'
        //     }else if(base.pdfType.indexOf(str)>=0){
        //         result = '3'
        //     }else{
        //         result = '5'
        //     }
        //     return result
        // },
        //导出
        // exportOut(){
        //     var token = this.$store.state.token;
        //     window.open(myHttp.getExportInspectsByGroupId+'?groupId='+this.groupId+'&unit='+this.search.unit+'&date='+this.search.date+'&accessToken='+token)
        // },
        //查看
        handleEdit(index,row){
            this.$router.push('/saleFile/'+row.id)
        },
        //返回
        goBack(){
            this.$router.go(-1);
        },
        //下载文档
        downFile(url){
            window.open(base.httpCtx+url)
        },
        //查看模板
        showModel(id,type){
            this.$router.push('/folderRules/'+this.cuid+'/'+id+'/'+type+'/'+this.entProjectId)
            
        },
        //查看原件
        showWord(id,type){
            this.$router.push('/desModel/'+this.cuid+'/'+id+'/'+type)
           
        },
    }
}
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header-box{
        padding: 15px 20px;
        height: 70px;
        width: 100%;
        box-shadow: 1px 2px 3px 2px #ddd;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #2058D9;
    }
    .box{
        margin-top: 15px;
        width: 100%;
        height: calc( 100% - 70px );
    }
    .box-content{
        width: 100%;
        height: calc( 100% - 80px );
        /* background: #fff; */
        overflow: auto;
        /* display: flex;
        align-content: flex-start; */
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 80px;
        background: #fff;
        border-bottom: 3px solid #17b2fe;
        padding: 0 20px;
    }
    .el-button{
        background: #FFF;
        border: 1px solid #DCDFE6;
        color: #606266;
    }
    .primary{
        background-color: #17b2fe;
        border-color: #17b2fe;
        color: #fff;
    }
    .table-item{
        width: 100%;
        min-height: 50px;
        display: flex;
        border-bottom: 15px solid #ecf0f5;
        background: #fff;
    }
    .flex-wrap{
        display: flex;
        flex-wrap: wrap;
    }
    .item-con{
        padding: 10px;
    }
    .item-con p{
        margin: 0;
        margin-bottom: 15px;
        width: 100%;
        text-align: center;
        font-size: 14px;
    }
    .item-con img{
        cursor: pointer;
    }
    .table-item-sec{
        width: 100%;
        height: 50px;
        background: #17B2FE;
        color: #fff;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 15px solid #ecf0f5;
    }
    .nowrap {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
</style>
<style>
    .build-bar span{
        margin-left: 0;
    }
    .el-table td, .el-table th{
        text-align: center;
    }
    /* .el-dialog{
        width: 500px;
    } */
</style>